import { render } from "./AdminLists.vue?vue&type=template&id=1bb21e6f"
import script from "./AdminLists.vue?vue&type=script&lang=js"
export * from "./AdminLists.vue?vue&type=script&lang=js"

import "./AdminLists.vue?vue&type=style&index=0&id=1bb21e6f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__